exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cashout-indicator{fill:var(--light-gray);margin:0 2px}.cashout-indicator--valid{fill:var(--green)}", ""]);

// exports
